import { JSEncrypt } from 'jsencrypt'
// 新建JSEncrypt对象
const encryptor = new JSEncrypt()
// 设置公钥
encryptor.setPublicKey(process.env.VUE_APP_RSA_PUBLIC_KEY)
export function encrypt(data) {
  return encryptor.encrypt(data)
}



// WEBPACK FOOTER //
// ./src/util/rsa.js